import React, { useEffect, useRef } from 'react';
import hero from '../img/hero.png';
import { NavLink } from "react-router-dom";
import RegisterService from '../api-services/RegisterService';
import Masonry from '../masonry';

interface Props {
  value?: string;
  children?: React.ReactNode;
}

const ImageElement: React.FC<Props> = React.memo(props => {
  return(
    <div className="card shadow-sm">
      <img src={props.value} className="img-fluid" />
    </div>
  )
})

function Awards() {
  return (
    <div className="container">
      <div className="row p-4 py-4 rounded-3 border shadow-lg">
        <div className="col-lg-12">
          <h3 id="story">2023</h3>
          <Masonry
            dataArray={["/img/awards/awards-1.webp"]}
            columnCount={1}
            ChildsElement={ImageElement}
          />
          <p>The BestUKVets Awards celebrate veterinary practices that delight their clients and are presented to practices across the UK with the most 4 or 5 star online reviews in each category.</p>
          <p>In 2023 we made history as the only practice to win Best Vet UK in our opening year. We also won Best New Start-Up, Best in England, Best in Essex and Top 25. As the overall winner, we attended the London Awards ceremony and held a local celebration the following day with as many pet owners as the village hall could comfortably accommodate.</p>
          <Masonry
            dataArray={[
              "/img/awards/awards-2.webp",
              "/img/awards/awards-3.webp",
              "/img/awards/awards-4.webp",
              "/img/awards/awards-5.webp"]}
            columnCount={2}
            ChildsElement={ImageElement}
          />
          <h3 id="story">2024</h3>
          <p>In 2024 we attended the BestUKVets Awards ceremony and dominated for the second year in a row. We were crowned Best Small Vet UK 2024 and received an armful of trophies, including Best New Vet UK. A highlight was being presented with the very special Elite Award in recognition of our commitment to maintaining our exceptional standards.</p>
          <Masonry
            dataArray={[
              "/img/awards/awards-6.webp",
              "/img/awards/awards-7.webp",
              "/img/awards/awards-8.webp",
              "/img/awards/awards-9.webp"]}
            columnCount={2}
            ChildsElement={ImageElement}
          />
          <p>Before the end of 2024, we added two more awards to our collection (cue more jokes from visitors regarding the need for an extension to house them all!) We've always known our reception team are the very best. I have worked with several during my career and our ladies are exceptional in every single way, so I was thrilled this was made official when they were awarded the title of “Best Veterinary Reception Team UK.” If you are already registered with us, this award won't surprise you in the slightest. I honestly cannot sing their praises loudly enough.</p>
          <Masonry
            dataArray={["/img/awards/awards-10.webp"]}
            columnCount={1}
            ChildsElement={ImageElement}
          />
          <p>We are also delighted to be recognized at a local level and received the runner up trophy for Empowering Women at the Tendring4Growth Awards 2024.</p>
          <Masonry
            dataArray={["/img/awards/awards-11.webp"]}
            columnCount={1}
            ChildsElement={ImageElement}
          />
          <h3 id="story">2025</h3>
          <p>For the third year in a row we triumphed at the BestUKVets Awards, holding onto our crown as Best Small Vet UK and the recipient of the Elite Award (amongst other accolades).</p>
          <Masonry
            dataArray={[
              "/img/awards/awards-12.webp",
              "/img/awards/awards-13.webp",
              "/img/awards/awards-14.webp",
              "/img/awards/awards-15.webp"]}
            columnCount={2}
            ChildsElement={ImageElement}
          />
          <p>Running a business is incredibly hard work and the veterinary profession is often high stakes and high pressure. Opening Weeley Veterinary Centre was only ever to allow myself and a small team of carefully chosen colleagues to care for our patients to the best of our ability. Providing we had enough clients to keep our doors open and we knew we were making a real difference to lives, that would have been good enough. The success and recognition we have received during the last three years was beyond my imagination when I was creating our practice. I consider myself the luckiest person alive to love my vocation and to know the impact it has had on so many in our local community.</p>
          <p>Thank you so much for all the support we have been shown and continue to receive. It means the world to us.</p>
          <p>April</p>
        </div>
      </div>
    </div>
  );
}

export default Awards;
